import assign from 'lodash/assign'
import * as session from 'common/session'
import Vue from 'vue'
import Router from 'vue-router'

import { route_map, routes } from './routes'

let route_names = Object.keys(route_map)
route_names.forEach(name => {
  let route = route_map[name]
  route.name = name
  route.meta = route.meta || {}
})

Vue.use(Router)

let router = new Router({routes})

// 一个假的用户信息
let dummy = {
  $$is_super: false,
  $$is_channel: false,
  $$is_teacher: false,
  roles: [],
  $$roles: {manager: false, teacher: false, president: false},
  auth: [],
  $$auth: {},
  dummy: true,
}

// 用于 router-link
let $location = Object.create(null)
route_names.forEach(name => {
  // 用于 router-link，给出路由，如 $location.login() 给出登录页的路由。
  // 需要注意默认会把当前页面的 query 参数带到下个页面，如果不需要把参数带过去，可以用 $location.login(false)
  // 可以指定参数，如：$location.file_center({department_uid: 'xxx'})
  $location[name] = function (query, mergeQuery = true) {
    // 合并当前页面的 url 参数
    if (mergeQuery && query !== false) query = assign({}, router.currentRoute.query, query)
    return {name, query: query || undefined}
  }
  // 判断某个路由是否有权限进入，一般用在 router-link 的 v-if 上。参数和 $location[name] 一致
  $location[name].auth = (query, mergeQuery = true) => {
    // 合并当前页面的 url 参数
    if (mergeQuery && query !== false) query = assign({}, router.currentRoute.query, query)
    let auth = route_map[name].meta.auth
    return auth ? auth(Vue.prototype.$user || dummy, query || {}) : true
  }
})

// 路由导航钩子。检查是否未登录，未登录则跳到登录页；
// 检查是否有权限进入页面，没有权限则跳转到 default 页面
router.beforeEach(async (to, from, next) => {
  // 访问有些页面并不需要用户登录
  if (to.meta.auth === false) {
    Vue.prototype.$user = Vue.prototype.$user || dummy
    next()
    return
  }
  try {
    // 组件实例添加用户对象 $user
    let $user = Vue.prototype.$user = await session.check()
    let redirect_default = (to_path) => {
      if ($user.$$is_super) { // super 默认进入渠道管理页
        next($location.admin_channel())
      } else if ($user.$$is_channel) { // channel 默认进入学校管理页
        next($location.admin_school())
      } else if (to_path === '/') {
        if ($user.$$roles.manager) { // 有 manager role 的 teacher 默认进入管理页
          next('/admin')
        } else if ($user.$$roles.teacher) { // 有 teacher role 的 teacher 默认进入首页
          next('/home')
        } else { // 其他就当管理了
          next('/admin')
        }
      } else {
        next()
      }
    }
    if (to.path === '/' || to.path === '/admin') { // 进入默认页面
      redirect_default(to.path)
    } else if (!to.meta.auth || to.meta.auth($user, to.query)) { // 进入其他页面，有权限则继续
      next()
    } else if (to.meta.redirect) { // 没有权限时，若指定了 redirect，则跳转到 redirect
      next(to.meta.redirect)
    } else { // 否则跳转到默认页
      redirect_default('/')
    }
  } catch (e) {
    // 获取用户信息失败，跳转到 login
    next('/login')
  }
})

if (process.env.NODE_ENV === 'development') {
  window.Router = Router
  window.router = router
}

export default router

const install = Vue => {
  if (install.installed) return
  Vue.prototype.$location = $location
}

Vue.use({install})



// WEBPACK FOOTER //
// ./src/router/index.js